<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="box" v-if="order.length>0">
          <div class="panel-header">
            <div class="panel-title">주문 현황</div>
          </div>
          <div class="panel-content grid" :style="gridStyle(order.length)">
            <div v-for="(item,idx) in order" :key="`order-${idx}`"
                 class="content-box" @click="routerPush(getPath('launchpack/templates/all'))">
              <div class="content-box-title">{{ item.label }}</div>
              <div class="lp-count">{{ item.count|currencyNum }}</div>
              <div class="content-s-wrapper">오늘 <span class="content-s primary">{{ item.today_count|currencyNum }}</span></div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SuperadminPartnerDashboard",
    created() {
      this.getData();
    },
    data() {
      return {
        order: [],
      }
    },
    methods: {
      getData() {
        this.$axios.get(this.getUrl('dashboard')).then(res => {
          this.order = res.data.order;
        });
      },
      gridStyle(n) {
        return `grid-template-columns:repeat(${n}, 1fr)`;
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'

  .panel-title
    color $main
    font-size 21px
    font-weight 300

  .panel-content
    padding 20px

  .content-title
    font-size 15px
    margin-bottom 8px

  .box
    padding 0

  .panel-header
    padding 16px 20px
    display flex
    align-items center
    justify-content space-between
    border-bottom 1px solid #eeeeee

  .content-box
    padding 16px 24px
    border 1px solid #eee
    border-left 0
    cursor pointer
    user-select none

  .content-box:first-child
    border-left 1px solid #eee
    border-top-left-radius 6px
    border-bottom-left-radius 6px

  .content-box:last-child
    border-top-right-radius 6px
    border-bottom-right-radius 6px

  .content-box:hover
    background-color #eee

  .content-box-title
    font-size 14px
    color #787878
    margin-bottom 8px

  .content-box-data
    font-size 18px
    font-weight 600

  .lp-count
    font-size 18px
    line-height 18px
    font-weight 600

  .content-s-wrapper
    margin-top 4px
    font-size 13px

  .content-s
    margin-left 4px
    font-weight 700

  .primary
    color $primary

  .chart-label
    display flex
    align-items center
    gap 0 4px
    font-size 13px
    color #4A4A4A

  .chart-count
    font-size 14px

  .grid
    display grid
</style>
